module.exports = __webpack_public_path__ + "static/media/unknown_cat.4b7d30db.png";